import { FC, ReactNode } from "react"

import { baseAuthTitleContainer } from "./AuthTitle.css"

export const AuthTitle: FC<{ children: ReactNode }> = ({ children }) => (
  <div className={baseAuthTitleContainer}>{children}</div>
)
